<template>
  <div class="shortlist col-xs-12 col-sm-6 col-lg-4">
    <div>
      <div class="col-xs-4">
        <img :src="user.profile_image_url" />
        <span class="position">{{ user.response.priority }}</span>
      </div>
      <div class="col-xs-8">
        <div class="description-small">
          <h4>
            {{ user.name }}
            <i v-if="user.profile.visibility === 'hidden' && ($userIsAdmin || $userIsManager)" class="fa fa-eye-slash text-grey" aria-label="hidden" title="hidden"/>
            <i v-if="user.profile.visibility === 'private' && ($userIsAdmin || $userIsManager)" class="fa fa-lock text-grey" aria-label="private" title="private"/>
          </h4>
          <p>{{ user.profile.tagline }}</p>
          <p v-if="!$clientConfig.hide_social_media_references" :title="`${user.profile.highest_followers} followers`">
            <i :class="['fab', user.profile.highest_followers_icon]"></i> {{ user.profile.highest_followers | abbreviatedNumber }} followers
          </p>
        </div>
      </div>
    </div>
    <div style="text-align: right;">
      <a v-if="editing" style="padding-right: 30px; cursor: pointer;" @click.prevent="handleRemoveCallback">Remove</a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { alert, notify } from 'utils'

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState('booking/request/vetting', { booking: 'request' }),
    ...mapState('editing', ['editing'])
  },

  methods: {
    ...mapActions('shortlist', ['removeStar', 'setShortlist', 'storeShortlist']),
    ...mapActions('booking/request/vetting', [
      'deleteVettingBookingRequestShortlistedTalent',
      'removeVettingBookingRequestShortlistedTalent'
    ]),

    /**
     * Handle removing a talent from the shortlist.
     *
     * @return Promise
     */
    handleRemoveCallback () {
      if (this.removingShortlistedTalent) {
        return Promise.resolve()
      }

      this.removingShortlistedTalent = true

      return alert.confirm({
        title: 'Remove Shortlisted Talent',
        text: `Are you sure you want to remove ${this.user.name} from the shortlist?`,
        buttons: {
          confirm: {
            text: 'Yes, remove talent.'
          }
        }
      }).then(() => {
        const payload = {
          id: this.booking.id,
          talentId: this.user.id
        }

        return this.deleteVettingBookingRequestShortlistedTalent(payload)
          .then(() => {
            notify.success(`${this.user.name} was removed from the shortlist.`)
          })
          .then(() => {
            this.removeVettingBookingRequestShortlistedTalent(this.user.id)
          })
      }).catch((error) => {
        this.removingShortlistedTalent = false

        if (error.response && error.response.data.message) {
          notify.error(error.response.data.message)
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .shortlist{
    &{
      margin-top: 15px;
      margin-bottom: 15px;
      min-height: 120px;
    }
  }
</style>
